// Keep the editable document intact; compact only the copy sent to record storage.
export const prepareHandoutRecordPayload = (payload) => {
  const copy = (value, preservePreviewCache = false) => {
    if (Array.isArray(value)) return value.map((item) => copy(item, preservePreviewCache));
    if (!value || typeof value !== "object") return value;

    const result = Object.fromEntries(Object.entries(value).map(([key, item]) => [
      key, copy(item, preservePreviewCache || key === "originalAsset"),
    ]));
    if (preservePreviewCache || typeof result.url !== "string" || !result.url.trim()) return result;

    // A different preview may represent a newer drawing; its pixels must survive.
    for (const key of ["_preview_url", "_previewUrl"]) {
      if (result[key] === result.url) delete result[key];
    }
    if (!result._preview_url && !result._previewUrl) delete result._preview_source_code;
    return result;
  };
  return copy(payload);
};
